
import { createRouter, createWebHistory } from "vue-router";
const Home = () => import("../views/Home.vue");
const AboutUs = () => import("../shared/components/footer/AboutUs.vue")
const TermsAndConditions = () => import("../shared/components/footer/TermsAndConditions.vue")
const ResponsibleGaming = () => import("../shared/components/footer/ResponsibleGaming.vue")
const Faq = () => import("../shared/components/footer/Faq.vue")
const Login = () => import("@/modules/authorization/components/Login.vue");
const SignUp = () => import("@/modules/authorization/components/SignUp.vue");
const ForgetPassword = () => import("@/modules/authorization/components/ForgetPassword.vue");
const MaintenanceComponent = () => import("@/shared/components/maintenance/Maintainence.vue");
import SportsRoutes from "@/modules/sports";
import WalletRoutes from "@/modules/wallet";
import RaceRoutes from "@/modules/race";
import VirtualSportRoutes from "@/modules/virtual-sport";
import CricketFightRoutes from "@/modules/cricket-fight"
import ReferEarnRoutes from "@/modules/refer-earn";
import BonusRoutes from "@/modules/bonus";
import StatmentRoutes from "@/modules/statment";
import GamesRoutes from "@/modules/games";
import MatkaRoutes from "@/modules/matka";
import NotificationsRoutes from "@/modules/notification";
import RulesRoutes from "@/modules/rules";
import NotFound from "../shared/components/no-data/404.vue";
import AffiliateRoutes from "@/modules/affiliate"

const routes = [
    {
        path: "/",
        name: "Home1",
        component: Home,
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
    },
    {
        path: "/about-us",
        name: "AboutUs",
        component: AboutUs
    },
    {
        path: "/about-us",
        name: "AboutUs",
        component: AboutUs
    },
    {
        path: "/terms-conditions",
        name: "terms-conditions",
        component: TermsAndConditions
    },
    {
        path: "/responsible-gaming",
        name: "responsible-gaming",
        component: ResponsibleGaming
    },
    {
        path: "/faq",
        name: "faq",
        component: Faq
    },
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "/sign-up",
        name: "sign-up",
        component: SignUp
    },
    {
        path: "/forget-password",
        name: "forget-password",
        component: ForgetPassword
    },
    { 
        path: '/:pathMatch(.*)*',
        name: 'NotFound', 
        component: NotFound 
      },
      {
        path: "/maintenance",
        name: "Maintenance",
        component: MaintenanceComponent
      },
    SportsRoutes,
    WalletRoutes,
    RaceRoutes,
    VirtualSportRoutes,
    ReferEarnRoutes,
    BonusRoutes,
    CricketFightRoutes,
    StatmentRoutes,
    GamesRoutes,
    MatkaRoutes,
    NotificationsRoutes,
    RulesRoutes,
    AffiliateRoutes

];


export default createRouter({
    history: createWebHistory(),
    routes
});

